import { RefreshCwIcon } from "lucide-react";
import { useState } from "react";

import { SettingsPageContainer } from "../settings/settingsLayout";
import { Button } from "../ui/button";
import {
  AvailablePluginsSection,
  InstalledPluginsSection,
  PluginsPageChrome,
  PluginsSearchField,
} from "./PluginPageSections";
import { usePluginConnections } from "./PluginConnectionsProvider";

export function PluginsPage() {
  const [query, setQuery] = useState("");
  const { plugins, loading, error, attempts, connect, disconnect, refresh } =
    usePluginConnections();

  return (
    // The scroller moved down: `SettingsPageContainer` is `flex-1 overflow-y-auto`
    // and the chrome above it is `shrink-0`, so the view switcher stays pinned
    // while the list moves under it. That pairing is what does the work —
    // `overflow-hidden` here does not cause it, it states the consequence, that
    // `<main>` itself never scrolls. Measured: swapping it back to
    // `overflow-auto` changes nothing under the explicit height, so treat it as
    // an assertion of intent rather than a mechanism.
    <main className="flex h-[calc(100dvh-var(--forge-app-top-bar-height))] min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-background">
      <PluginsPageChrome
        activeView="plugins"
        search={<PluginsSearchField query={query} onQueryChange={setQuery} />}
        refreshButton={
          <Button
            type="button"
            size="icon-sm"
            variant="ghost"
            aria-label="Refresh plugins"
            onClick={() => void refresh()}
          >
            <RefreshCwIcon className="size-4" />
          </Button>
        }
      />
      <SettingsPageContainer>
        <InstalledPluginsSection
          plugins={plugins}
          loading={loading}
          attempts={attempts}
          onConnect={connect}
          onDisconnect={disconnect}
        />
        <AvailablePluginsSection
          plugins={plugins}
          loading={loading}
          error={error}
          query={query}
          attempts={attempts}
          onConnect={connect}
        />
      </SettingsPageContainer>
    </main>
  );
}
